import { createAction } from 'redux-act';

export const fetchLoginState = createAction('fetch login state');
export const failFetchingLoginState = createAction('fail fetching login state');

export const fetchUser = createAction('fetch user');
export const failFetchingUser = createAction('fail fetching user');

export const externalSite = createAction('externalSite');

export const initialUser = createAction('intial user');

export const login = createAction('login');
export const clickLogout = createAction('click logout');
export const logout = createAction('logout');

export const cancelOrder = createAction('cancel order');

export const updateUser = createAction('update user');
export const updatePassword = createAction('update password');
export const reminderUpdatePassword = createAction('reminder update password');
export const failUpdateUser = createAction('fail update user');
export const successUpdateUser = createAction('success update user');
export const successReminderUpdatePassword = createAction(
  'success reminder update password'
);



// WEBPACK FOOTER //
// ./src/actions/auth.js